module.exports = __webpack_public_path__ + "static/img/fnj002.082257f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fnj002.png
// module id = sqsx
// module chunks = 143